import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const BoostDexscreener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Boost Dexscreener - Buy Dexscreener Reaction Service | Dexreaction</title>
        <meta name="description" content="Boost Dexscreener trending score with reactions & visitors! Buy Dexscreener reaction to increase token visibility, rankings, social proof. Natural patterns, instant start. Cheapest prices from $0.05/reaction!" />
        <meta name="keywords" content="boost dexscreener, buy dexscreener reaction, buy dexscreener rockets, buy dexscreener fire, buy dexscreener poop, dexreactions, dexscreener boost, boost dexscreener trending, dexscreener trending boost, increase dexscreener visibility, dexscreener ranking boost, dexscreener visitors, dexscreener traffic boost, cheap dexscreener reactions" />
        <link rel="canonical" href="https://dexreaction.com/boost-dexscreener" />
        <meta property="og:title" content="Boost Dexscreener - Buy Dexscreener Reaction | Dexreaction" />
        <meta property="og:description" content="Boost Dexscreener trending with reactions! Natural patterns, instant delivery from $0.05!" />
        <meta property="og:image" content="https://dexreaction.com/og-image.png" />
        <meta property="og:image" content="https://dexreaction.com/logo-light.png" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-slate-900 via-emerald-900/20 to-slate-900">
        {/* Header */}
        <nav className="fixed top-0 w-full bg-slate-900/80 backdrop-blur-md border-b border-emerald-500/20 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                <img src="/logo-light.png" alt="Dexreaction" className="h-8" />
              </div>
              <button onClick={() => navigate('/')} className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                Get Started
              </button>
            </div>
          </div>
        </nav>

        {/* Hero */}
        <section className="pt-32 pb-20 px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 bg-emerald-500/20 text-emerald-300 px-6 py-3 rounded-full font-semibold mb-6">
                <span className="relative flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-500"></span>
                </span>
                Live Boosting Service
              </div>
              <h1 className="text-5xl md:text-7xl font-bold mb-6">
                <span className="bg-gradient-to-r from-emerald-400 via-teal-400 to-cyan-400 bg-clip-text text-transparent">
                  Boost DexScreener
                </span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
                Comprehensive boosting service to skyrocket your token's visibility and rankings on DexScreener
              </p>
            </div>

            {/* Key Metrics */}
            <div className="grid md:grid-cols-3 gap-6 mb-12">
              {[
                { icon: '📈', title: 'Boost Rankings', desc: 'Climb trending lists' },
                { icon: '👥', title: 'Boost Visibility', desc: 'Reach more investors' },
                { icon: '💎', title: 'Boost Credibility', desc: 'Build social proof' }
              ].map((item, idx) => (
                <div key={idx} className="bg-gradient-to-br from-emerald-900/30 to-teal-900/30 border border-emerald-500/30 rounded-xl p-6 text-center hover:border-emerald-500/50 transition-all">
                  <div className="text-4xl mb-3">{item.icon}</div>
                  <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                  <p className="text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="text-center">
              <button
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white px-10 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105 inline-flex items-center gap-2"
              >
                🚀 Start Boosting Now
              </button>
            </div>
          </div>
        </section>

        {/* Boosting Benefits */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
              What Does DexScreener Boosting Include?
            </h2>
            <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
              Our comprehensive boosting service includes everything you need to succeed
            </p>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { icon: '🚀', title: 'Reaction Boosting', desc: 'Get authentic reactions from real accounts to boost engagement' },
                { icon: '📊', title: 'Ranking Improvement', desc: 'Improve position in trending and hot lists on DexScreener' },
                { icon: '👁️', title: 'Visibility Increase', desc: 'Make your token more discoverable to potential investors' },
                { icon: '⚡', title: 'Fast Delivery', desc: 'Instant processing with 500 reactions per 10 minutes' },
                { icon: '🎯', title: 'Targeted Growth', desc: 'Choose specific reaction types that match your token sentiment' },
                { icon: '💰', title: 'Best Value', desc: 'Competitive pricing with 20% bonus reactions on all orders' }
              ].map((item, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-emerald-500/20 rounded-xl p-6 hover:border-emerald-500/50 transition-all">
                  <div className="text-3xl mb-3">{item.icon}</div>
                  <h3 className="text-lg font-bold mb-2">{item.title}</h3>
                  <p className="text-sm text-gray-400">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How Boosting Works */}
        <section className="py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              How DexScreener Boosting Works
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-emerald-900/30 to-teal-900/30 border border-emerald-500/30 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-6">1. Choose Boost Package</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <span className="text-emerald-400">✓</span>
                    <span className="text-gray-300">Select quantity (500-10,000+ reactions)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-emerald-400">✓</span>
                    <span className="text-gray-300">Get 20% bonus reactions automatically</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-emerald-400">✓</span>
                    <span className="text-gray-300">All packages start at just $0.05/reaction</span>
                  </li>
                </ul>
              </div>
              <div className="bg-gradient-to-br from-emerald-900/30 to-teal-900/30 border border-emerald-500/30 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-6">2. Select Reaction Type</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <span className="text-2xl">🚀</span>
                    <span className="text-gray-300">Rocket - for bullish tokens</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-2xl">🔥</span>
                    <span className="text-gray-300">Fire - for trending tokens</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-2xl">⭐</span>
                    <span className="text-gray-300">Favorite - for community tokens</span>
                  </li>
                </ul>
              </div>
              <div className="bg-gradient-to-br from-emerald-900/30 to-teal-900/30 border border-emerald-500/30 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-6">3. Provide Token Details</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <span className="text-emerald-400">✓</span>
                    <span className="text-gray-300">Enter your DexScreener token link</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-emerald-400">✓</span>
                    <span className="text-gray-300">We validate the link automatically</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-emerald-400">✓</span>
                    <span className="text-gray-300">Supports all Solana tokens on DexScreener</span>
                  </li>
                </ul>
              </div>
              <div className="bg-gradient-to-br from-emerald-900/30 to-teal-900/30 border border-emerald-500/30 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-6">4. Instant Boost Delivery</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <span className="text-emerald-400">✓</span>
                    <span className="text-gray-300">Pay securely with Solana (SOL)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-emerald-400">✓</span>
                    <span className="text-gray-300">Boost starts immediately after payment</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-emerald-400">✓</span>
                    <span className="text-gray-300">See results in real-time on DexScreener</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Boost Packages */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              DexScreener Boost Packages
            </h2>
            <div className="grid md:grid-cols-4 gap-6">
              {[
                { name: 'Quick Boost', qty: 500, price: 25, total: 600, badge: 'Starter' },
                { name: 'Power Boost', qty: 1000, price: 50, total: 1200, badge: 'Popular' },
                { name: 'Mega Boost', qty: 1500, price: 75, total: 1800, badge: 'Pro' },
                { name: 'Ultra Boost', qty: 2000, price: 100, total: 2400, badge: 'Premium' }
              ].map((pkg) => (
                <div key={pkg.name} className="bg-gradient-to-b from-emerald-900/30 to-slate-800/50 border-2 border-emerald-500/30 rounded-xl p-6 hover:border-emerald-500 transition-all transform hover:scale-105">
                  <div className="text-center">
                    <div className="inline-block bg-emerald-500/20 text-emerald-300 px-3 py-1 rounded-full text-xs font-bold mb-3">
                      {pkg.badge}
                    </div>
                    <h3 className="text-xl font-bold mb-2">{pkg.name}</h3>
                    <div className="text-4xl font-bold text-emerald-400 mb-2">${pkg.price}</div>
                    <div className="text-gray-400 mb-4">{pkg.qty} reactions</div>
                    <div className="bg-emerald-500/20 rounded-lg p-3 mb-4">
                      <div className="text-lg font-bold text-green-400">+20% FREE</div>
                      <div className="text-sm text-gray-300">Get {pkg.total} total</div>
                    </div>
                    <button
                      onClick={() => navigate('/')}
                      className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-3 rounded-lg font-semibold transition-colors"
                    >
                      Boost Now
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-center text-gray-400 mt-8">
              Need a custom boost? Contact us for enterprise packages up to 100,000+ reactions
            </p>
          </div>
        </section>

        {/* Success Stories */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12">
              Boost Success Stories
            </h2>
            <div className="space-y-6">
              {[
                { token: 'MemeCoin XYZ', boost: '2,400 reactions', result: 'Reached #3 on trending', change: '+350% visibility' },
                { token: 'DeFi Token ABC', boost: '1,200 reactions', result: 'Top 10 in category', change: '+240% engagement' },
                { token: 'Gaming Token DEF', boost: '1,800 reactions', result: 'Featured on homepage', change: '+180% volume' }
              ].map((story, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-emerald-500/20 rounded-xl p-6">
                  <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div>
                      <h3 className="text-lg font-bold mb-2">{story.token}</h3>
                      <p className="text-sm text-gray-400">Boosted with {story.boost}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-emerald-400 font-semibold mb-1">{story.result}</div>
                      <div className="text-2xl font-bold text-green-400">{story.change}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-16 px-4 bg-slate-900/50">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12">
              DexScreener Boosting FAQ
            </h2>
            <div className="space-y-4">
              {[
                { q: 'How does boosting improve my rankings?', a: 'Reactions are a key engagement metric on DexScreener. Higher reaction counts signal community interest and can improve your position in trending lists.' },
                { q: 'Is this safe for my token?', a: 'Completely safe. We use authentic accounts and natural delivery patterns that comply with DexScreener guidelines.' },
                { q: 'How fast will I see results?', a: 'Boosting starts immediately and you can see new reactions appearing on your DexScreener listing within minutes.' },
                { q: 'Can I boost multiple times?', a: 'Yes! You can place multiple orders to continue boosting your token as needed.' }
              ].map((faq, idx) => (
                <div key={idx} className="bg-slate-800/50 border border-emerald-500/20 rounded-xl p-6">
                  <h3 className="font-bold mb-2 text-emerald-400">{faq.q}</h3>
                  <p className="text-gray-400">{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ready to Boost Your DexScreener?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Join hundreds of tokens that boosted their visibility with Dexreaction
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white px-12 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105"
            >
              Start Boosting Today 🚀
            </button>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-slate-900 border-t border-emerald-500/20 py-8 px-4">
          <div className="max-w-6xl mx-auto text-center text-gray-400">
            <p>&copy; 2025 Dexreaction. All rights reserved.</p>
            <div className="mt-4 space-x-4">
              <button onClick={() => navigate('/terms')} className="hover:text-emerald-400 transition-colors">Terms</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-emerald-400 transition-colors">Privacy</button>
              <button onClick={() => navigate('/')} className="hover:text-emerald-400 transition-colors">Contact</button>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default BoostDexscreener;
